'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuggestionValue = exports.getSectionSuggestions = exports.getSuggestedSpots = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSuggestedSpots = exports.getSuggestedSpots = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(serviceConfig, value, size) {
    var querySize, suggestionSize, searchUrl, response, body;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            querySize = size;
            suggestionSize = size;

            searchUrl = function searchUrl(namePrefix) {
              return serviceConfig.serviceUrl + '/search/site' + ('?q=' + namePrefix + '&querySize=' + querySize + '&suggestionSize=' + suggestionSize);
            };

            _context.next = 5;
            return fetch(searchUrl(value), {
              method: 'GET',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }
            });

          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.json();

          case 8:
            body = _context.sent;

            if (!(response.status === 200)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt('return', body);

          case 11:
            return _context.abrupt('return', []);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getSuggestedSpots(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var getSectionSuggestions = exports.getSectionSuggestions = function getSectionSuggestions(section) {
  var suggest = section.suggest,
      error = section.error,
      hits = section.hits;


  if (error) {
    return [];
  }

  if (hits && hits.hits && hits.hits.length > 0) {
    return hits.hits;
  }

  var suggestTypes = ['spot-suggest', 'subregion-suggest', 'geoname-suggest'];

  var suggestTypeVal = suggestTypes.find(function (type) {
    return suggest[type];
  });
  return suggestTypeVal ? suggest[suggestTypeVal][0].options : [];
};

var getSuggestionValue = exports.getSuggestionValue = function getSuggestionValue(suggestion) {
  if (suggestion && suggestion.text) {
    return suggestion.text;
  }
  // eslint-disable-next-line no-underscore-dangle
  return suggestion._source.name;
};


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewSpotSearch/NewSpotSuggestion/NewSpotSuggestionModel.js
// module id = 303
// module chunks = 0